export const SUPPORT_EMAIL = "support@areaofpeople.com";
export const MOBILE_WIDTH = 768;
